import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextInput } from "../../../components/controls/inputs";
import BaseCreator from "../../../components/creators/baseCreator";
import { useForm } from "../../../system/hooks/useForm";
import modalStyles from '../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { IStorePlaceGetDTO } from "../../../libs/coreapi-dto/dirs/storePlace";
type Validator = Pick<IStorePlaceGetDTO, 'name'>

const StorePlaceCreatorModal: FC<ICreatorModalProps<IStorePlaceGetDTO>> = (props) => {

    const [storePlace, setStorePlace] = useState<IStorePlaceGetDTO>(props.data ?? {} as IStorePlaceGetDTO);

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.storePlace.' + value);
    const errorsT = (value: string) => t('errors.' + value);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const { isValid, errors, setErrors } = useForm<Validator>({
        validations: {
            name: {
                required: {
                    value: storePlace.name ? false : true,
                    message: errorsT("required")
                }
            },
        }
    });

    const handleSubmit = () => {
        if (isValid()) {
            props.save({ ...storePlace })
            setIsSubmitting(true)
        }
    }

    return (
        <BaseCreator
            modalWindowClassName={modalStyles.flexModalWindow}
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            valid={!props.lockFromPermission}
        >
            <GridWrapper cols={1}>
                <TextInput
                    label={baseT('mnemocode')} value={storePlace.mnemocode}
                    disabled={true}
                />
            </GridWrapper>
            <GridWrapper cols={2}>
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('name')} 
                    value={storePlace.name}
                    onChange={(value) => setStorePlace({ ...storePlace, name: value })}
                    error={errors.name} onFocus={() => setErrors({ ...errors, name: undefined })} 
                    disabled={props.lockFromPermission}
                />
                <TextInput
                    label={baseT('description')} value={storePlace.description}
                    onChange={(value) => setStorePlace({ ...storePlace, description: value })}
                    disabled={props.lockFromPermission}
                />

            </GridWrapper>
          
        </BaseCreator>
    )
}

export default StorePlaceCreatorModal